interface LoadingProps {
  // Render as a page-level placeholder that clears the fixed top header. Use this
  // for transitional placeholders rendered directly in the AppView content area
  // (which has no top offset of its own); leave it off for inline uses inside
  // menus, dialogs and already-offset views.
  page?: boolean;
}

export function Loading({ page }: LoadingProps = {}) {
  return (
    <div className={page ? "Loading Loading-page" : "Loading"}>Loading...</div>
  );
}
